/**
 * PATH: apps/hr/src/components/settings/AlertPoliciesSettingsTab.tsx
 * PURPOSE: Alert policies settings tab content for the Settings modal (real-data only)
 *
 * WHY:
 * - Previously this tab used mock alert policies, which must not ship to production.
 * - Alert policies are not yet backed by an HR API in this hub.
 */

import { Bell } from 'lucide-react'
import { EmptyState } from '../ui/EmptyState'

export function AlertPoliciesSettingsTab() {
  return (
    <EmptyState
      icon={Bell}
      title="Alert policies not connected"
      description="This settings tab has been cleaned up to remove dummy data. Once alert policies are backed by a real API, configuration will appear here."
    />
  )
}

export default AlertPoliciesSettingsTab
